import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import ReactSelect from '../../../../../components/ReactSelect';

export const ALL_BRANDS = 'all';
export const PROJECT_BRANDS = 'project';

class AdditionalBox extends Component {
    render() {
        const { t, brandOptions, selectedBrand, handleSelectBrand } = this.props;

        const options = [
            { label: t('ai_tracking.keyword_detail.facts.filters.all_brands'), value: ALL_BRANDS },
            {
                label: t('ai_tracking.keyword_detail.facts.filters.project_brands'),
                value: PROJECT_BRANDS,
            },
            ...brandOptions,
        ];

        return (
            <div className="table-additional-view justify-content-start">
                <div>
                    <ReactSelect
                        options={options}
                        value={options.find((x) => x.value === selectedBrand)}
                        isSearchable={false}
                        placeholder={t('ai_tracking.keyword_detail.facts.filters.placeholder')}
                        onChange={handleSelectBrand}
                        blurInputOnSelect={true}
                        classname="mr-10"
                    />
                </div>
            </div>
        );
    }
}

export default withTranslation()(AdditionalBox);
